<template>
  <div class="mobile-menu__wrapper">
    <a-link
      class="mobile-menu__single-parent-item"
      :class="menuParentClasses"
      :to="parent.Link"
      :trailing-slash="$helper.isLinkWithTrailingSlash(parent.Link)"
      @click="onParentItemClick(parent.Link)"
    >
      {{ parent.Name }}
      <span
        :class="menuArrowClassName"
        @click.prevent.stop="toggleMenu"
        @touchend.stop
      />
    </a-link>
    <collapse-transition>
      <ul v-show="isExpanded" class="mobile-menu__child-items-container">
        <li
          v-for="(child, childIndex) in parent.ChildItems"
          :key="`${child.Name}-${childIndex}`"
          class="mobile-menu__child-item"
        >
          <a-header-menu-block-items
            v-if="isNestedLevelDisplayed(child)"
            :parent="child"
            :nesting-level="nestingLevel + 1"
            @onCloseMenu="onItemClick"
          />
          <a-link
            v-else
            class="mobile-menu__single-child-item text-primary-navigation bold"
            :to="child.Link"
            :trailing-slash="$helper.isLinkWithTrailingSlash(child.Link)"
            @click="onItemClick"
          >
            {{ child.Name }}
          </a-link>
        </li>
        <slot name="bottom-items" :on-item-click="onItemClick" />
      </ul>
    </collapse-transition>
  </div>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import { HEADER_ITEM_ID } from '@/components/AHeader/enums'

export default {
  name: 'AHeaderMenuBlockItems',
  props: {
    parent: propValidator([PROP_TYPES.OBJECT]),
    nestingLevel: propValidator([PROP_TYPES.NUMBER], false, 0)
  },
  data() {
    return {
      isExpanded: false
    }
  },
  computed: {
    menuArrowClassName() {
      return this.isExpanded
        ? 'parent-item__arrow_up'
        : 'parent-item__arrow_down'
    },
    menuParentClasses() {
      return {
        expanded: this.isExpanded
      }
    }
  },
  methods: {
    toggleMenu() {
      this.isExpanded = !this.isExpanded
    },
    onParentItemClick(link) {
      if (!link) {
        this.toggleMenu()
        return
      }

      this.onItemClick()
    },
    onItemClick() {
      this.$emit('onCloseMenu')
    },
    isNestedLevelDisplayed(child) {
      return child.ChildItems && child.ChildItems.length
    },
    setMenuAsExpandedForSpecialItem() {
      if (this.parent.Id === HEADER_ITEM_ID.MORE) {
        this.toggleMenu()
      }
    }
  },
  mounted() {
    this.setMenuAsExpandedForSpecialItem()
  }
}
</script>

<style lang="scss" scoped>
$item-gap: 12px;

.mobile-menu__wrapper {
  padding-top: $item-gap;
  padding-bottom: $item-gap;

  .mobile-menu__child-items-container {
    padding-left: 6px;
    max-width: 420px;
  }

  .mobile-menu__child-item {
    cursor: pointer;

    .mobile-menu__wrapper {
      padding: 0;
    }
  }

  .mobile-menu__single-child-item {
    width: 100%;
    position: relative;
    display: block;
    cursor: pointer;
    padding: $item-gap 0;
    transition: color 0.3s;
    color: white;
  }

  .mobile-menu__single-parent-item {
    width: 100%;
    font-size: 14px;
    font-weight: 500;
    position: relative;
    display: inline-flex;
    cursor: pointer;
    padding: $item-gap 25px $item-gap 0;
    transition: color 0.3s;
    color: white;
  }

  .parent-item__arrow {
    &_down,
    &_up {
      &::after,
      &::after {
        margin-left: 10px;
        content: '';
        border: solid $c--main;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 3px;
        transition: transform 0.3s;
      }
    }

    &_down::after {
      margin-bottom: 3px;
      transform: rotate(45deg);
    }

    &_up::after {
      transform: rotate(225deg);
    }
  }
}
</style>
